import React, { type FunctionComponent } from 'react'
import { type GridProps } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { type ProductsSearchDatum } from 'domains/products/components/search/utils/types'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { PaginatedGrid, defaultItemsPerPageValues } from '@retailer-platform/shared-components'
import { colors } from 'gin-and-tonic/foundation/colors'
import { defaultLineHeight } from 'gin-and-tonic/foundation/fontSize'
import { fontWeight } from 'gin-and-tonic/foundation/fontWeight'

const MakeSearchContainer = styled.div({
  padding: '20vh 0',
  textAlign: 'center',
  color: '#7D7D7D',
  fontStyle: 'italic',
  lineHeight: defaultLineHeight,
})

const MakeSearchTip = styled.div({
  textAlign: 'center',
  color: colors.GRAYSCALE.X70,
  fontWeight: fontWeight.REGULAR,
})

interface ProductsSearchTableProps
  extends Omit<GridProps<ProductsSearchDatum>, 'height' | 'emptyStateMessage'> {
  onPageChange: (page: number) => void
  page: number
  totalPages: number
  disablePagination?: boolean
  itemsPerPage: number
  onItemsPerPageChange: (number) => void
  emptyStateMessageTip?: string
}

export const ProductsSearchTable: FunctionComponent<ProductsSearchTableProps> = props => {
  const messages = useDomainMessages({
    noResults: 'productsDomain.search.noResults',
    makeSearch: 'productsDomain.search.makeSearch',
  })

  const noResults = props.data && messages.noResults
  const makeSearch = !props.data && (
    <MakeSearchContainer>
      {messages.makeSearch}
      <MakeSearchTip>{props.emptyStateMessageTip}</MakeSearchTip>
    </MakeSearchContainer>
  )

  return (
    <PaginatedGrid
      emptyState={makeSearch}
      emptyStateMessage={noResults}
      emptyStateShowHeader={!makeSearch}
      showItemsPerPageSelector={true}
      itemsPerPageValues={defaultItemsPerPageValues}
      loadingRowsCount={props.itemsPerPage}
      {...props}
      data={props.data || []} // PaginatedGrid doesn't like null or undefined data
    />
  )
}
